import { Language } from "../languages/labels/language.labels";

export function typeCommissionList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'fixed', display: lang.labels.fixed },
    { code: 'percentage', display: lang.labels.percentage },
    { code: 'none', display: lang.labels.none }
  ]
}

export function typeCommissionValue(lang: Language, code: string): string {
  let type = typeCommissionList(lang).find((item) => (item.code === code))
  return type ? type.display : lang.labels.undefined
}
